import React, { useCallback, useMemo } from 'react'
import message from 'antd/lib/message'

import { apiManager } from 'helpers'
import { TabSwitch } from 'components'

const WaitlistToggle = ({ user }) => {
  const filters = useMemo(
    () => [
      {
        label: 'Waitlist',
        key: 'waitlist',
        isActive: user.waitlist,
      },
      {
        label: 'Off',
        key: 'off',
        isActive: !user.waitlist,
      },
    ],
    [user]
  )

  const handleFilter = useCallback(
    async ({ key }) => {
      try {
        await apiManager.updateWaitlistStatus({
          user: user.id,
          data: {
            waitlist: key === 'waitlist',
          },
        })
      } catch (error) {
        message.error(error?.message || 'An error occurred, please try again')
      }
    },
    [user]
  )

  if (!user.admin) {
    return null
  }

  return (
    <div className="hidden mb-3 md:flex">
      <div className="flex bg-tunaGray rounded-lg p-1.5">
        <TabSwitch buttonClassName="w-20" tabs={filters} onChange={handleFilter} />
      </div>
    </div>
  )
}

export default WaitlistToggle
